import CheckboxRenderer from "components/common/ag-grid/CheckboxRenderer";
import HrAdminBadge from "./HrAdminBadge";

export const columnDefs = [
  { 
    headerName: 'ID#',
    field: 'id',
    minWidth: 110,
    headerCheckboxSelection: true,
    checkboxSelection: true
  },
  { 
    headerName: 'Name',
    field: 'name',
    minWidth: 300
  },
  { 
    headerName: 'Country',
    field: 'country_name',
    minWidth: 150
  },
  { 
    headerName: 'Active',
    field: 'active',
    minWidth: 100,
    cellRenderer: CheckboxRenderer
  },
  { 
    headerName: 'HR Admin',
    field: 'hr_admin',
    minWidth: 100,
    cellRenderer: HrAdminBadge
  },
  { 
    headerName: 'Travel booking',
    field: 'travel_booking',
    minWidth: 100,
    cellRenderer: CheckboxRenderer
  }
];